import { useTranslation } from '@frontend/i18n';
import { ContainedIcon } from '@frontend/icons';
import { Photos } from '@frontend/photos';
import { AiAssistant } from '@frontend/styled-icons';
import { theme } from '@frontend/theme';
import { Truncated, Text } from '@frontend/design-system';

export const AiOfficeUserRouted = ({ name, userId }: { name?: string; userId?: string }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'grid',
        alignItems: 'center',
        gridAutoFlow: 'column',
        gap: theme.spacing(0.5),
      }}
    >
      <AiAssistant />
      <ContainedIcon iconName='caret-right' size={12} />
      {userId && (
        <Photos.ContactProfilePhoto
          personId={userId ?? ''}
          // Only show the first initial since this is a small avatar
          name={name ? name.split(' ')[0] : undefined}
          title={name}
          disableClick={true}
          size='small'
          css={{ width: 20, height: 20, minWidth: 20, minHeight: 20 }}
        />
      )}
      <Truncated as={Text} size='medium' color='default'>
        {name ?? t('Office User')}
      </Truncated>
    </div>
  );
};

export const AiOfficeUser = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'grid',
        alignItems: 'center',
        gridAutoFlow: 'column',
        gap: theme.spacing(0.5),
      }}
    >
      <AiAssistant />
      <Truncated as={Text} size='medium' color='default'>
        {t('AI Receptionist')}
      </Truncated>
    </div>
  );
};
